import { format, parseISO } from 'date-fns';
import { openNotifyModal } from '@src/library/redux/modal/index.ts';
import * as st from './styles.module.scss';

export const handleNotAvailableByScheduleVideoClick = (date: string) => {
  const parsedDate = parseISO(date);
  return openNotifyModal({
    title: 'Видео недоступно',
    needClose: true,
    text: `Видео станет доступным ${format(parsedDate, 'dd.MM.yyy')} в ${format(parsedDate, 'hh:mm')}`,
    confirmText: 'Понятно',
    buttonClassName: st.button,
  });
};
